import { useCallback } from 'react';

import { fetchUserInfoAction } from '../apiActions/fetchUserInfoAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useUserInfoFetcher = (essential: boolean): ((force?: boolean) => void) => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const baseUrl = useConfigSlice.baseUrl();

  return useCallback(
    (force?: boolean) => {
      if (JSESSIONID && baseUrl) {
        dispatch(
          fetchUserInfoAction({
            JSESSIONID,
            force,
            baseUrl,
            essential, // Balance fetching should always be essential
          })
        );
      }
    },
    [JSESSIONID, baseUrl, dispatch, essential]
  );
};
